/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
import { __ } from '@wordpress/i18n';

import CourseFilterItem from './CourseFilterItem';

/**
 * CourseListItem Component
 * @param {Object} props
 * @returns {JSX.Element}
 */
function CourseFilter({ filters }) {
	return (
		<div className="course__filters">
			<h2>{__('Filters', 'kotisivu-block-theme')}</h2>
			<div className="course__filter">
				<>
					<h3>{__('Categories', 'kotisivu-block-theme')}</h3>
					<CourseFilterItem
						type="category"
						values={filters.category}
					/>
					<h3>{__('Countries', 'kotisivu-block-theme')}</h3>
					<CourseFilterItem type="country" values={filters.country} />
					<h3>{__('Locations', 'kotisivu-block-theme')}</h3>
					<CourseFilterItem type="venue" values={filters.venue} />
				</>
			</div>
		</div>
	);
}

export default CourseFilter;
